import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Share2 } from "lucide-react";
import { api } from "@/lib/api";

export default function NewsArticle() {
  const { slug } = useParams();
  const [item, setItem] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setItem(null); setNotFound(false);
    api.get(`/news/${slug}`).then((r) => setItem(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <section className="pt-40 pb-24 max-w-[1400px] mx-auto px-6 text-center">
        <h1 className="font-cinzel uppercase text-white text-4xl mb-6">Notícia não encontrada</h1>
        <Link to="/legacy-news" className="btn-outline"><ArrowLeft size={14} /> Voltar</Link>
      </section>
    );
  }
  if (!item) return <div className="pt-40 pb-24 text-center text-neutral-500">A carregar...</div>;

  const share = () => {
    if (navigator.share) navigator.share({ title: item.title, url: window.location.href });
    else navigator.clipboard.writeText(window.location.href);
  };

  return (
    <>
      <section className="pt-32 pb-16 border-b border-white/5">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <Link to="/legacy-news" className="section-eyebrow inline-flex items-center gap-2 hover:text-white mb-8">
            <ArrowLeft size={12} /> Legacy News
          </Link>
          <div className="text-[#A67C00] text-[0.65rem] tracking-[0.3em] uppercase mb-6">{item.category}</div>
          <h1 className="font-cinzel uppercase text-white text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] mb-8">
            {item.title}
          </h1>
          <div className="flex items-center justify-between text-neutral-500 text-xs tracking-[0.25em] uppercase pb-6">
            <span>{new Date(item.date).toLocaleDateString("pt-PT", { day: "2-digit", month: "long", year: "numeric" })} · {item.author}</span>
            <button onClick={share} data-testid="news-share" className="inline-flex items-center gap-2 hover:text-[#A67C00]">
              <Share2 size={12} /> Partilhar
            </button>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <div className="relative aspect-[16/9] overflow-hidden mb-12">
            <img src={item.image} alt={item.title} className="absolute inset-0 w-full h-full object-cover" />
          </div>
          <p className="text-neutral-200 text-lg leading-relaxed mb-6">{item.summary}</p>
          <div className="text-neutral-300 leading-relaxed whitespace-pre-line">{item.content}</div>
        </div>
      </section>
    </>
  );
}
